/**
 * Formats a number as a string, padding it at the start with a specified fill string to reach a desired length.
 *
 * @param {number} number - The number to format.
 * @param {number} maxLength - The desired length of the resulting string.
 * @param {string} fillString - The string to pad the number with at the start if necessary.
 * @returns {string} The formatted number as a string, padded at the start if needed.
 */
const formatNumber = (number, maxLength, fillString) => {
  return number.toString().padStart(maxLength, fillString)
}

export default formatNumber
